<div class="container my-4">
  <div class="mb-2 flex justify-content-between">
    <patron-filter-widget [findOptions]="findOptions" (onSubmit)="goToFirstPage()" #filter>
    </patron-filter-widget>
    <patron-button
      (onClick)="openTicketVersionModal()"
      iconName="pi-sync"
      [disabled]="!hasProject || !checkedTickets.length || !isUpdateAssistantCanWrite()">
      Atualizar chamados
    </patron-button>
  </div>

  <patron-modal
    [visible]="ticketVersionInfoVisible"
    (confirm)="updateTicketsVersionInfo()"
    [confirmButtonLoading]="updateLoading"
    title="Atualizar chamados"
    [backdrop]="'static'"
    confirmButtonText="Atualizar chamados">
    <patron-form [formGroup]="formGroup">
      <patron-form-field
        [formGroup]="formGroup"
        formControlName="project"
        label="Projeto"></patron-form-field>
      <patron-select
        [formGroup]="formGroup"
        formControlName="environment"
        [items]="environmentOptions"
        bindValue="value"
        bindLabel="label"
        label="Ambiente"
        (onChange)="onEnvironmentChange($event)"
        [help]="{ text: 'Informe o ambiente que foi liberado, se é homologação ou produção' }">
      </patron-select>
      <patron-form-field
        [formGroup]="formGroup"
        formControlName="version"
        label="Versão"
        maxlength="10"
        [help]="{
          text: 'Informe a versão que foi liberada (máximo 10 caracteres). Ex: 26.10.19-1',
        }">
      </patron-form-field>
      <patron-textarea
        [formGroup]="formGroup"
        formControlName="message"
        label="Mensagem"
        [help]="{ text: 'Mensagem sobre a versão' }">
      </patron-textarea>
      <patron-select
        [formGroup]="formGroup"
        formControlName="update_status"
        [items]="updateStatusOptions"
        orderBy="*"
        bindValue="value"
        bindLabel="label"
        label="Atualizar status"
        [help]="{ customTemplate: statusHelp }">
      </patron-select>
      <ng-template #statusHelp>
        <p>Deseja atualizar o status dos chamados?</p>
        <p>O status do chamado e das tarefas será atualizado conforme selecionado.</p>
        <p>Normalmente usamos o seguinte padrão:</p>
        <p>Homologação => <patron-badge color="warning">Testar</patron-badge></p>
        <p>Produção => <patron-badge>ATUALIZAÇÃO DE RELEASE</patron-badge></p>
      </ng-template>

      @if (formGroup.get('update_status')?.value) {
        <patron-select
          [formGroup]="formGroup"
          formControlName="status"
          modelName="ticket-statuses"
          label="Status"
          bindLabel="description">
        </patron-select>
      }
    </patron-form>

    @if (
      formGroup.get('project')?.value &&
      formGroup.get('environment')?.value &&
      formGroup.get('version')?.value
    ) {
      <p>
        Mensagem:
        <patron-alert>
          {{ formGroup.get('message')?.value }}
          [{{ formGroup.get('project')?.value }} liberado em
          {{ formGroup.get('environment')?.value == 'homologation' ? 'homologação' : 'produção' }}
          versão {{ formGroup.get('version')?.value }}]
        </patron-alert>
      </p>
    }
    <p class="mb-0">Chamados a serem atualizados:</p>
    <ul patron-list-group class="mt-2 mb-3">
      @for (ticket of checkedTickets; track ticket) {
        <li patron-list-group-item class="flex flex-column">
          <span class="font-bold">{{ ticket.ticket_number_teorema }}</span>
          @if (ticket.summary) {
            <small [innerHTML]="ticket.summary | truncate: [90]"></small>
          }
          <div>
            @if (ticket.ticket_status; as status) {
              <patron-badge [color]="getStatusClass(status.description)">
                {{ status.description }}
              </patron-badge>
            }
            @if (formGroup.get('update_status')?.value) {
              <span>
                =>
                @if (formGroup.get('status')?.value?.description; as status) {
                  <patron-badge [color]="getStatusClass(status)">
                    {{ status }}
                  </patron-badge>
                }
              </span>
            }
          </div>
        </li>
      }
    </ul>
  </patron-modal>

  @if (!hasProject) {
    <div class="mt-4">
      <patron-alert class="text-center font-bold"
        >Filtre por um projeto para ver os chamados</patron-alert
      >
    </div>
  }

  @if (hasProject) {
    <patron-responsive-table
      [items]="revisions"
      [bodyTemplate]="body"
      [loading]="loading"
      [enableSelection]="true"
      [findOptions]="findOptions"
      #table>
      <ng-template #body let-item>
        <tr (click)="table.rowClicked(item)" [class.bg-primary]="table.isChecked(item)">
          <td>
            <patron-form-check
              [inputTemplate]="checkInputTemplate13"
              [inputContext]="{ $implicit: item }">
              <ng-template #checkInputTemplate13 let-item>
                <input
                  type="checkbox"
                  [id]="item.id"
                  [checked]="table.isChecked(item)"
                  (change)="table.toggleCheck(item, true)" />
              </ng-template>
            </patron-form-check>
          </td>
          <td>
            <span class="font-bold">{{ item.ticket?.ticket_number_teorema }}</span> <br />
            <small
              [innerHTML]="item.ticket?.summary | truncate: [40]"
              [patron-tooltip]="item.ticket?.summary"></small>
          </td>
          <td>
            <small
              [innerHTML]="item.ticket?.customer?.person?.name | truncate: [25]"
              [patron-tooltip]="item.ticket?.customer?.person?.name"></small>
          </td>
          <td>
            <small>
              {{ item.ticket?.system?.description }}
            </small>
          </td>
          <td>{{ item.id_commit }}</td>
          <td>{{ item.version }}</td>
          <td>
            @if (item.ticket?.ticket_status; as status) {
              <patron-badge [color]="getStatusClass(status.description)">
                {{ status.description }}
              </patron-badge>
            }
          </td>
          <td>
            <small>
              {{ item.developer?.name ?? 'Sem desenvolvedor' }}
            </small>
          </td>
          <td>
            <patron-button
              (click)="openTicketModal(item)"
              size="sm"
              iconName="pi-eye"></patron-button>
          </td>
        </tr>
      </ng-template>
    </patron-responsive-table>
  }

  <app-ticket-detail-modal
    [ticketId]="currentTicketId ?? null"
    [visible]="modalVisible"
    (visibleChange)="onModalVisibleChange($event)"
    (ticketUpdated)="onTicketUpdated($event)">
  </app-ticket-detail-modal>
</div>

<patron-toolbar position="bottom" [class.hidden]="!revisions.length">
  <patron-paginator
    [totalRecords]="totalItems"
    [findOptions]="findOptions"
    (onPageChange)="paginate($event)"
    #paginator>
  </patron-paginator>
</patron-toolbar>
